<script>

  /**
   * @exports MTableResizableMixin
   * @class MTableResizableMixin
   * @requires MTableWidthMixin
   */
  export default {
    name: 'MTableResizableMixin',
    props: {
      resizable: Boolean
    },
    created () {
      if (this.resizable) {
        this.class['resizable-table'] = true;
        this.registerHeaderEventsListener('column-resize', this.handleUpdateColumnSizes.bind(this));
      }
    },
    methods: {

      /**
       * Handle column resizing, accepts new Column width, process calculations and update grid-template-columns
       * Column component shouldn`t change it`s width by itself
       * @param key - column index
       * @param value - column width
       */
      handleUpdateColumnSizes ({key, value}) {
        this.setColumnWidth(key, value);
        this.afterResizeUpdate();
      }
    }
  };
</script>

<style>
  .resizable-table .m-table-header-resize-node {
    display: block;
  }
</style>
